'use client';
import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { SearchInput } from '../search-input/search-input.component.js';
import { ComboboxInput } from './combobox-input.component.js';
import { useSwanComboboxContext } from './combobox.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const ComboboxSearchInput = renderWithRef('ComboboxSearchInput', null, (n, a)=>{
    let { inputRef: u, triggerRef: b, setInputValue: l } = useSwanComboboxContext(), { overlayState: f } = useSwanPopover(), m = assignRefs(a, u), getSearchInputProps = (e)=>_object_spread_props(_object_spread({}, e), {
            onClear: (e)=>{
                var r;
                null === (r = n.onClear) || void 0 === r || r.call(n, e), l('');
            }
        });
    return useEffect(()=>{
        let e = u.current, cb = (e)=>{
            let r = f.selectionManager.focusedKey;
            if ('Enter' === e.key && !r) {
                var t;
                let e = null === (t = b.current) || void 0 === t ? void 0 : t.querySelector('button[type="submit"]');
                null == e || e.click();
            }
        };
        return null == e || e.addEventListener('keydown', cb), ()=>null == e ? void 0 : e.removeEventListener('keydown', cb);
    }, [
        u,
        b,
        f
    ]), jsx(RenderComp, {
        root: "div",
        forwardedRef: b,
        classNames: [
            'swan-combobox-search-input-container'
        ],
        props: {},
        children: jsx(ComboboxInput, _object_spread_props(_object_spread({}, n), {
            ref: m,
            render: (r, t)=>jsx(RenderComp, {
                    root: SearchInput,
                    forwardedRef: t,
                    props: getSearchInputProps(r)
                })
        }))
    });
});

export { ComboboxSearchInput };
